import { classNames } from "@helpers/css";

import { CompetencySharing } from "./competency-sharing";
import { sharingToneClassName } from "./competency-sharing-tone";

// Sits under the criterion being edited, coloured by how far that edit
// reaches: amber for the whole organization, blue beyond this career track,
// grey for here only.
// Only the tone and the line are read, so a row that isn't a competency (a
// role's or a person's responsibilities) can pass just those.
const CompetencySharingChip = ({
  sharing,
}: {
  sharing: Pick<CompetencySharing, "tone" | "effect">;
}) => (
  <div
    className={classNames(
      "mt-2 inline-block rounded-sm px-1.5 py-0.5 text-xs",
      sharingToneClassName[sharing.tone],
    )}
    aria-label="Competency sharing"
  >
    {sharing.effect}
  </div>
);

export default CompetencySharingChip;
